import { Button, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { getFDplans } from "../../../ApiServices/Apifun";
import { useDispatch, useSelector } from "react-redux";
import { setselectedTab } from "../../../Store/B2bslice";
import { Images } from "../../../Controller";
import { useNavigate } from "react-router-dom";
import FdCalculator from "../../../Common/FDcalculator";

const FixedDeposit = () => {
  const navigate = useNavigate();
  const [spinner, setSpinner] = useState(false);
  const [fdSettings, setFDsettings] = useState([]);
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const dispatch = useDispatch();

  const getAllFDplans = () => {
    setSpinner(true);
    getFDplans()
      .then((res) => {
        setFDsettings(res.data.fd_setting);
      })
      .catch((err) => console.log(err))
      .finally(() => setSpinner(false));
  };
  useEffect(() => {
    dispatch(setselectedTab("302"));
    if (!memberServices.includes("302")) {
      navigate("/not-Available");
    } else {
      getAllFDplans();
    }
  }, []);

  return (
    <>
      <p className="font-semibold text-xl">Fixed Deposit</p>
      <Spin spinning={spinner}>
        {fdSettings && fdSettings.length !== 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
            {fdSettings?.map((i, index) => {
              return (
                <div
                  key={index}
                  className="bg-white shadow-lg hover:shadow-2xl transition-all duration-300 rounded-2xl p-6 border border-gray-100 relative group"
                >
                  {/* Plan Header */}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary/10">
                      <img
                        src={Images.circleShape}
                        alt="plan"
                        className="w-5 h-5"
                      />
                    </div>
                    <h2 className="text-lg font-semibold text-gray-800 capitalize">
                      {i.plan_name}
                    </h2>
                  </div>

                  {/* Plan Details */}
                  <div className="grid grid-cols-2 gap-y-3 gap-x-4 text-sm text-gray-600">
                    <div>
                      <p className="text-gray-400">Min Amount</p>
                      <p className="font-medium text-gray-800">
                        ₹ {i.min_amount}
                      </p>
                    </div>

                    <div>
                      <p className="text-gray-400">Max Amount</p>
                      <p className="font-medium text-gray-800">
                        ₹ {i.max_amount}
                      </p>
                    </div>

                    <div>
                      <p className="text-gray-400">Interest Rate</p>
                      <p className="font-medium text-green-600">
                        {i.interest_rate}%
                      </p>
                    </div>

                    <div>
                      <p className="text-gray-400">Compounding</p>
                      <p className="font-medium text-gray-800">
                        {i.compounding}
                      </p>
                    </div>

                    <div>
                      <p className="text-gray-400">Min Tenure</p>
                      <p className="font-medium text-gray-800">
                        {i.min_tenure_months} Months
                      </p>
                    </div>

                    <div>
                      <p className="text-gray-400">Max Tenure</p>
                      <p className="font-medium text-gray-800">
                        {i.max_tenure_months} Months
                      </p>
                    </div>

                    <div className="col-span-2">
                      <p className="text-gray-400">Premature Rate</p>
                      <p className="font-medium text-red-500">
                        {i.premature_rate}%
                      </p>
                    </div>
                  </div>

                  {/* <button
                    onClick={() => {
                      setResponse(i);
                      setIsOpen(true);
                    }}
                    className="mt-6 w-full bg-primary text-white py-2 rounded-xl font-semibold hover:bg-green-600 transition-all duration-300 shadow-md hover:shadow-lg"
                  >
                    Pay Now
                  </button> */}
                </div>
              );
            })}
            <div className="">
              <FdCalculator
                minAmount={fdSettings[0]?.min_amount || 0}
                maxAmount={fdSettings[0]?.max_amount || 0}
                minTenure={fdSettings[0]?.min_tenure_months || 0}
                maxTenure={fdSettings[0]?.max_tenure_months || 0}
              />
            </div>
          </div>
        ) : (
          <div className="flex justify-center items-center h-40 text-gray-400">
            No Plans Available
          </div>
        )}
      </Spin>
      {/* {isOpen && (
        <PayModal
          details={{
            benificiary_name: response.account_holder,
            benificiary_account: response.account_no,
            benificiary_ifsc: response.ifsc_code,
          }}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      )} */}
    </>
  );
};

export default FixedDeposit;
